import PaymentHistoryAPI from '../../configs/api/payment/PaymentHistory'

const paymentHistory = {
  namespaced: true,
  state: {
    listPaymentHistory: [],
    nextUrl: {},
    totalPage: 0,
    currentPage: 1,
    paymentDetail: {}
  },
  mutations: {
    CHANGE_LIST_PAYMENT_HISTORY (state, payload) {
      state.listPaymentHistory = payload
    },
    CHANGE_TOTAL_PAGE (state, payload) {
      state.totalPage = payload
    },
    CHANGE_CURRENT_PAGE (state, payload) {
      state.currentPage = payload
    },
    CHANGE_PAYMENT_DETAIL (state, payload) {
      state.paymentDetail = payload
    }
  },
  actions: {
    // asynchronus fetch API data
    async getPaymentHistoryListV4 ({ rootState, commit }, payload) {
      const result = await PaymentHistoryAPI.postV2(`/v4/list/${payload.query.current_page}/10`, { token: rootState.storage.accessToken, data: payload.data })
      if (result.status === 200 || result.message === 'OK') {
        commit('CHANGE_LIST_PAYMENT_HISTORY', result.data)
        commit('CHANGE_TOTAL_PAGE', result.total_page)
      } else {
        commit('CHANGE_LIST_PAYMENT_HISTORY', [])
        commit('CHANGE_TOTAL_PAGE', 0)
        commit('CHANGE_CURRENT_PAGE', 1)
      }
    },
    async getPaymentDetailV4 ({ rootState, commit }, payload) {
      const result = await PaymentHistoryAPI.getV2(`/v4/detail/${payload.id}`, { token: rootState.storage.accessToken })
      if (result.status === 200 || result.message === 'OK') {
        commit('CHANGE_PAYMENT_DETAIL', result.data)
        return result
      } else {
        return result
      }
    },
    async getPaymentDetailV5 ({ rootState, commit }, payload) {
      const result = await PaymentHistoryAPI.getV2(`/v5/detail/${payload.id}`, { token: rootState.storage.accessToken })
      if (result.status === 200 || result.message === 'OK') {
        commit('CHANGE_PAYMENT_DETAIL', result.data)
      }
      return result
    }
  },
  getters: {
    nextUrlStatus: state => {
      return state.nextUrl.status
    }
  }
}

export default paymentHistory
